'use client'

import Script from 'next/script'

// Admin-written custom script, injected in-page (site-wide) like the Meta Pixel — NOT sandboxed.
// Author is a trusted superadmin, so the script gets full page access (pixels, widgets, etc).
// Splits the code into <script> tags (run via next/script) and any leftover markup (rendered as HTML).
function parseCustomScript(code: string) {
  const scripts: { src?: string; body?: string }[] = []
  const html = code.replace(/<script\b([^>]*)>([\s\S]*?)<\/script>/gi, (_m: string, attrs: string, body: string) => {
    const src = /\bsrc\s*=\s*["']([^"']+)["']/i.exec(attrs)?.[1]
    scripts.push(src ? { src } : { body })
    return ''
  }).trim()
  // No <script> tag and no HTML markup → treat the whole paste as a raw JS snippet.
  if (scripts.length === 0 && html && !/<[a-z!/]/i.test(html)) {
    return { html: '', scripts: [{ body: code }] }
  }
  return { html, scripts }
}

export default function CustomScript({ code }: { code: string }) {
  if (!code?.trim()) return null
  const { html, scripts } = parseCustomScript(code)
  return (
    <>
      {html ? <div dangerouslySetInnerHTML={{ __html: html }} /> : null}
      {scripts.map((s, i) =>
        s.src
          ? <Script key={i} src={s.src} strategy="afterInteractive" />
          : <Script key={i} id={`custom-script-${i}`} strategy="afterInteractive" dangerouslySetInnerHTML={{ __html: s.body || '' }} />
      )}
    </>
  )
}
